import React, { useMemo } from 'react'
import CaretLeftIcon from '@tecuity/sos-icons/react/caret-left'
import CaretRightIcon from '@tecuity/sos-icons/react/caret-right'
import './Pager.scss'
import { useSelector, shallowEqual } from 'react-redux'

const Pager = ({
  pageSizeLabel,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50],
  onPrevClicked,
  onNextClicked,
  category,
  hidden,
}) => {
  const { edges } = useSelector((state) => state.search, shallowEqual)
  const edge = edges[category] || {}
  const { PageSize = 10, PageNum = 1, TotalRows } = edge

  const numberWithCommas = (x) => {
    return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
  }

  const currentRows = useMemo(() => {
    const startRowNum = PageSize * (PageNum - 1) + 1
    const endRowNum = PageSize * PageNum >= TotalRows ? TotalRows : PageSize * PageNum
    return `${numberWithCommas(startRowNum)} - ${numberWithCommas(endRowNum)}`
  }, [PageSize, TotalRows, PageNum])

  return (
    <div className="pager-container" style={{ visibility: hidden ? 'hidden' : 'visible' }}>
      <div className="page-size-label" aria-label={pageSizeLabel || 'Rows per page:'}>
        {pageSizeLabel || 'Rows per page:'}
      </div>
      <select
        aria-label={`${pageSizeLabel || 'rows per page'} dropdown`}
        onChange={onPageSizeChange}
        value={PageSize}
        className="page-size"
      >
        {pageSizeOptions.map((opt, i) => {
          return (
            <option value={opt} key={i}>
              {opt}
            </option>
          )
        })}
      </select>
      <div />
      <div />
      <div role="status" className="row-display-counts">{`${currentRows} of ${numberWithCommas(
        TotalRows
      )}`}</div>
      <button
        onClick={onPrevClicked}
        disabled={PageNum === 1}
        className="pager-button"
        aria-label="Previous Page"
      >
        <CaretLeftIcon />
      </button>
      <button
        onClick={onNextClicked}
        disabled={PageSize * PageNum >= TotalRows}
        className="pager-button"
        aria-label="Next Page"
      >
        <CaretRightIcon />
      </button>
    </div>
  )
}

export default Pager

// return (
//   <div className="pager">
//     { activePage === 1 ?
//       null
//       :
//       <button onClick={onPrevClicked} aria-label="Previous Page">
//         <CaretLeftIcon />
//       </button>
//     }
//     {new Array(numPages).fill(null).map((_, i) => (
//       <button
//         onClick={() => onPageClicked(i + 1)}
//         className={`${activePage === i + 1 ? 'active' : ''}`}
//         key={i}
//       >
//         {i + 1}
//       </button>
//     ))}
//     { activePage === numPages ?
//       null
//       :
//       <button onClick={onNextClicked} aria-label="Next Page">
//         <CaretRightIcon />
//       </button>
//     }
//   </div>
// )
// Pager.propTypes = {
//   numPages: PropTypes.number.isRequired,
//   activePage: PropTypes.number,
//   onPrevClicked: PropTypes.func.isRequired,
//   onNextClicked: PropTypes.func.isRequired,
//   onPageClicked: PropTypes.func.isRequired
// }
